export class SideStats {
    A = 0;
    W = 0;
    F = 0;
    U = 0;
    DF = 0;
    aggressiveMargin = 0;
    serveWon = 0;
    servePlayed = 0;
    firstServePlayed = 0;
    firstServeWon = 0;
    secondServePlayed = 0;
    secondServeWon = 0;
    pointsWon = 0;
    returnMade = 0;
    returnWon = 0;
    firstServeReturnWon = 0;
    secondServeReturnWon = 0;
    breakPoint = 0;
    breakPointConverted = 0;
    shortRally = 0;
    mediumRally = 0;
    longRally = 0;
}
